import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { ITab } from "@shared/models/tab";
import { Router, RouterOutlet } from "@angular/router";
import { BEDSIDE_SHIFT_REPORT_URL_PATH } from "@shared/bedside-shift-report/constants";
import { AuthService } from "@auth/services/auth/auth.service";
import { TabsStateService } from "@shared/services/tabs-state/tabs-state.service";
import { tabIcons } from "@shared/models/tab-icons";
import { AppInsightsService } from "@api/services/app-insights/app-insights.service";
import { AppTopBarComponent } from "@layout/components/topbar/app.topbar.component";
import { LoaderComponent } from "@layout/components/loader/loader.component";
import { Toast } from "primeng/toast";
import { ConfirmDialog } from "primeng/confirmdialog";

@Component({
    selector: "app-layout",
    templateUrl: "./app.layout.component.html",
    styleUrls: ["./app.layout.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AppTopBarComponent, RouterOutlet, LoaderComponent, Toast, ConfirmDialog],
})
export class AppLayoutComponent {
    pagesToExcludeFooter = [BEDSIDE_SHIFT_REPORT_URL_PATH, "encounter-details"];

    private readonly authService = inject(AuthService);
    private readonly tabsService = inject(TabsStateService);
    private readonly router = inject(Router);
    private readonly appInsightsService = inject(AppInsightsService);

    handleTabClick(tab: ITab) {
        const queryParams = { tabId: tab.tabId, ...tab.queryParams };
        this.router.navigate([tab.tabComponentUrl], {
            queryParams: queryParams,
        });
    }

    handleLogoutClicked(): void {
        this.appInsightsService.clearContext();
        this.authService.logout();
    }

    handleSettingsClicked(): void {
        const newTab: ITab = {
            tabId: this.tabsService.findAvailableMaxTabId(),
            tabTitle: "Settings",
            tabTitleIconDefinition: tabIcons.Settings,
            tabComponentUrl: `/settings`,
            isActive: true,
            tabState: null,
        };
        this.tabsService.addTab(newTab);
    }

    handleChangeCentersClicked(): void {
        this.router.navigate(["/centers"]);
    }
}
